




























































/**
 * External dependencies.
 */
import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * Internal dependencies.
 */
import { namespace as profileModule } from '@/store/profile'
import { SET_GALLERY } from '@/store/profile/constants'
import { UserData } from '@/store/authentication/interfaces/UserData'
import { GalleryType } from '@/store/profile/enums/GalleryType'

import { scrollTo } from '@/utils/helpers'
import { namespace as authenticationModule } from '@/store/authentication'
import { namespace as commonModule } from '@/store/common'
import { Modes } from '@/store/common/enum/Modes'

@Component
export default class ProfileSubNav extends Vue {
  @Prop({ type: String, required: true }) currentComp: string
  @Prop({ type: Boolean, default: false }) isProfileCurrentUser: boolean

  GALLERY_PHOTOS = GalleryType.GALLERY_PHOTOS
  GALLERY_FAVORITES = GalleryType.GALLERY_FAVORITES

  @authenticationModule.Getter isLoggedIn: boolean
  @authenticationModule.Getter getUserData: UserData

  @commonModule.Getter getMode: Modes

  @profileModule.Getter isIsotopeReady: boolean
  @profileModule.Getter isGalleryLoading: boolean
  @profileModule.Getter getCurrentGalleryType: GalleryType
  @profileModule.Action(SET_GALLERY) setGallery: (type: GalleryType) => void

  get submissionsOpen () {
    return this.getMode === Modes.OPEN
  }

  setSelection (component: string, shouldScroll: boolean = true) {
    this.$emit('selectedComponent', {
      component,
      shouldScroll
    })
  }

  async goToGallery (type: GalleryType, owner: boolean) {
    if (owner) {
      this.setSelection('ProfileDefault', false)
    }

    await this.$nextTick()

    this.setGallery(type)

    await this.$nextTick()

    scrollTo('#user-gallery')
  }

  profileClicked () {
    this.submissionsOpen ? this.setSelection('ProfileUpload') : this.setSelection('ProfilePhotos')
  }

  // isActive (comp: string) {
  //   return comp === this.currentComp
  // }
}
